import { useRef } from 'react';

export default function PhotoUploader({ files, onChange }) {
  const inputRef = useRef();

  function handleAdd(e) {
    const newFiles = Array.from(e.target.files);
    onChange([...files, ...newFiles]);
    e.target.value = '';
  }

  function handleRemove(index) {
    onChange(files.filter((_, i) => i !== index));
  }

  return (
    <div className="photo-uploader">
      <div className="photo-previews">
        {files.map((file, i) => (
          <div key={i} className="photo-preview">
            <img src={URL.createObjectURL(file)} alt={`Preview ${i + 1}`} />
            <button type="button" className="photo-remove" onClick={() => handleRemove(i)}>&times;</button>
          </div>
        ))}
        <button type="button" className="photo-add" onClick={() => inputRef.current.click()}>
          <span>+</span>
          <small>Add Photo</small>
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple onChange={handleAdd} style={{ display: 'none' }} />
    </div>
  );
}
